module.exports = __webpack_public_path__ + "res/25-img_game_bg.b586c3751691c3019483881e57d6ab97.png";